import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#80B9FF',
        secondary: '#0073FF',
        accent: '#F6C54B',
      },
    },
  },
  breakpoint: {
    xl: 1600,
    // thresholds: {
    //   xl: 1600,
    // },
  },
});

